import { ChipRadioGroup } from "../../../../../core/Chip.js";
import type { BattlesFilterContent } from "../../../battlesContent.js";

/** Which battles the list shows, as filter chips: every battle, or the shopper's own. */
export function BattlesFilter({ value, label, options, onValueChange }: BattlesFilterContent) {
  return (
    <ChipRadioGroup label={label} value={value} options={options} onValueChange={onValueChange} />
  );
}
